import {
    request,
    requestPublic
} from './request.js'
// 获取幻灯片列表
export function getSlides() {
    return request({
        url: '/api2/ZsbSiteAdmin/Slide/GetSlides',
        method: 'get',
    })
}

// 添加幻灯片 
export function addSlide(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Slide/AddSlide',
        method: 'post',
        data: data
    })
}

// 编辑幻灯片 
export function editSlide(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/Slide/EditSlide',
        method: 'post',
        data: data
    })
}

// 删除幻灯片 
export function deleteSlide(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Slide/DeleteSlide',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 获取指定幻灯片信息 
export function getSlideDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/Slide/GetSlideDetail',
        method: 'get',
        params: {
            id: id
        }
    })
}